// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".row[data-v-ef01a4e0] {\n  margin-bottom: 1rem;\n}\ntable tr td input[type=text][data-v-ef01a4e0] {\n  width: 60%;\n}\n.form-control-label[data-v-ef01a4e0] {\n  color: #37474f;\n  font-weight: 500;\n  font-size: 1.286rem;\n  padding-left: 0px;\n  margin-bottom: 0.5em;\n}", ""]);
// Exports
module.exports = exports;
